import { getProperty } from 'reporting-data/v2/dataset/datasetRecords';
// @ts-expect-error migrate upstream file
import { getPropertyFormatter } from 'reporting-visualizations/formatters/propertyFormatter';
import { getPropertyFormatterOverrides } from '../../formatters/propertyFormatterUtils';
const getCompareDatasetName = primaryDatasetName => primaryDatasetName === 'primary' ? 'compare' : `${primaryDatasetName}_compare`;
export const getCompareValue = ({
  datasetName,
  fieldName,
  getDataset,
  abbreviateNumberIfPossible
}) => {
  const compareDatasetKey = datasetName && getCompareDatasetName(datasetName);
  const compareDataset = compareDatasetKey && getDataset(compareDatasetKey);
  let value;
  let label;
  if (compareDataset) {
    value = Number(compareDataset.getIn(['data', '0', fieldName]));
    if (value !== undefined && !isNaN(value)) {
      const maybeFormattablePropertyCompare = getProperty(compareDataset, fieldName);
      const formattableCompareOverrides = getPropertyFormatterOverrides(maybeFormattablePropertyCompare === null || maybeFormattablePropertyCompare === void 0 ? void 0 : maybeFormattablePropertyCompare.get('type'), abbreviateNumberIfPossible);
      label = getPropertyFormatter(maybeFormattablePropertyCompare, formattableCompareOverrides)(value);
    }
  }
  return {
    value,
    label
  };
};